import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SDKSelectComponent } from './sdk-select.component';

@NgModule({
	imports: [
		SDKSelectComponent,
	],
	exports: [
		SDKSelectComponent,
	],
	schemas: [
		NO_ERRORS_SCHEMA,
	]
})

export class SDKSelectModule { }
